<template>
  <el-select
    v-model="value"
    @change="change"
    clearable
    filterable

    placeholder="请选择DSP名称"
  >
    <el-option
      v-for="item in dspNameOptions"
      :key="item.dspId"
      :label="item.dspName"
      :value="item.dspId"
    />
  </el-select>
</template>

<script>
import { getDspName } from '@/api/select'
import { hot } from "@/api/hot"

export default {
  props: {
    modelValue: [String, Number],
    dspType: {
      type: Number,
      default: 1
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      dspNameOptions: [],
      value: undefined
    }
  },
  watch: {
    modelValue(newVal) {
      if (this.value === newVal) return
      this.value = newVal
    }
  },
  created() {
    this.getDspName()
  },
  methods: {
    getDspName() {
      if (this.dspType !== 100) {
        getDspName({ dspType: this.dspType }).then(res => {
          if (res.code === 200) {
            this.dspNameOptions = res.data
          }
        })
      } else {
        getDspName().then(res => {
          if (res.code === 200) {
            this.dspNameOptions = res.data
          }
        })
      }
    },
    change(item) {
      let data = {
        maker: "dspOnThe",
        onTheOrderId: item
      }
      if (item) {
        hot(data)
      }
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    },
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>
